import { MutationTree } from 'vuex';

import usedItems from '@/shared/mixins/store/usedItems';

import { subscribableStore } from './common';
import { SharedActivityTypesState } from './types';

const mutations: MutationTree<SharedActivityTypesState> = {
  ...subscribableStore.mutations,
  ...usedItems.mutations,
};

export default mutations;
